<template>
  <div class="headbar d-flex flex-column justify-content-center">
    <div class="row equal">
      <div class="col d-flex align-items-center">
        <sidebar-toggle></sidebar-toggle>
        <logo height="34px"></logo>
      </div>
      <div class="col-auto">
        <div class="headbar-controls clearfix d-none d-lg-block">
          <div class="top-profile">
            <a href="#" class="profile">
              <span>
                Hello
                <strong>{{ user.firstName }} {{ user.lastName }}</strong>
              </span>
              <img src="@/assets/profile.png" alt />
              <i class="uil uil-angle-down"></i>
            </a>
            <ul>
              <li>
                <a href="#">Profile</a>
              </li>
              <li>
                <a href="#">Update Account</a>
              </li>
              <li>
                <a href="#">Change Password</a>
              </li>
              <li>
                <a href="#">Sequrity Questions &amp; Answers</a>
              </li>
              <li>
                <a href="#">Adjust Timezone</a>
              </li>
              <li>
                <a href="#">Adjust Number &amp; Date format</a>
              </li>
              <li class="li-border-top">
                <span>
                  Customer ID:
                  <strong>287469</strong>
                </span>
              </li>
            </ul>
          </div>
          <div class="top-icons mr-3">
            <ul class="clearfix">
              <li>
                <a class="active" href="#">
                  <i class="uil uil-bell"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="uil uil-cog"></i>
                </a>
              </li>
            </ul>
          </div>
          <nav class="top-nav-menu">
            <ul>
              <li>
                <a href="#">Developers</a>
                <ul>
                  <li>
                    <a href="#">Sandbox</a>
                  </li>
                  <li>
                    <a href="#">APIs</a>
                  </li>
                  <li>
                    <a href="#">Plugins</a>
                  </li>
                  <li>
                    <a href="#">Tutorials</a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#">Documentation</a>
                <ul>
                  <li>
                    <a href="#">Integration into Shop Systems</a>
                  </li>
                  <li>
                    <a href="#">kopplr Checkout Page</a>
                  </li>
                  <li>
                    <a href="#">kopplr Checkout Seamless</a>
                  </li>
                  <li>
                    <a href="#">Back-end Operations</a>
                  </li>
                  <li>
                    <a href="#">Integration of specific Payment Methods</a>
                  </li>
                  <li>
                    <a href="#">kopplr Checkout Automated</a>
                  </li>
                  <li>
                    <a href="#">kopplr Checkout Terminal</a>
                  </li>
                  <li>
                    <a href="#">kopplr Payment Center</a>
                  </li>
                  <li>
                    <a href="#">Glossary</a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#">Support</a>
                <ul>
                  <li>
                    <a href="#">User Guides</a>
                  </li>
                  <li>
                    <a href="#">Tutorials</a>
                  </li>
                  <li>
                    <a href="#">FAQs</a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import SidebarToggle from '@/components/dashboard/SidebarToggle.vue'
import Logo from '@/components/header/Logo.vue'

export default {
  name: 'dashboard-header',
  components: {
    SidebarToggle,
    Logo
  },
  computed: {
    ...mapFields({
      user: 'user'
    })
  }
}
</script>
